"use strict";
/*
 * 8x8 Confidential & Proprietary || Copyright 2025 8x8, Inc. or its affiliates. All Rights Reserved.
 *  _____      _____
 * |  _  |    |  _  |
 *  \ V /__  __\ V /   ___ ___  _ __ ___
 *  / _ \\ \/ // _ \  / __/ _ \| '_ ` _ \
 * | |_| |>  <| |_| || (_| (_) | | | | | |
 * \_____/_/\_\_____(_)___\___/|_| |_| |_|
 *
 * @License https://www.8x8.com/terms-and-conditions/software-development-kit-license-agreement
 * @Author Comanici Paul
 * @Date 2025/08/28
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FILE_TRANSFER_STATUS = exports.FILE_TRANSFER_ACTIONS = void 0;
/**
 * File transfer action constants
 */
const FILE_TRANSFER_ACTIONS = {
    SEND_FILE: "send-file",
    CHUNK: "chunk",
    COMPLETE: "complete",
    ERROR: "error",
    CANCEL: "cancel",
};
exports.FILE_TRANSFER_ACTIONS = FILE_TRANSFER_ACTIONS;
/**
 * File transfer status constants
 */
const FILE_TRANSFER_STATUS = {
    UPLOADING: "uploading",
    COMPLETED: "completed",
    FAILED: "failed",
};
exports.FILE_TRANSFER_STATUS = FILE_TRANSFER_STATUS;
//# sourceMappingURL=constants.js.map